<template>
    <v-container fluid class="py-0 my-0 mt-2">
        <v-row align="center" class="py-0 my-0">
            <v-col md="12" sm="12" cols="12" class="py-0 my-0">
                <p class="google-font mb-0" style="font-weight: 350;font-size:200%"><b>
                    <span style="color: #1a73e8;">Unsere</span> Projekte </b> 
                </p>
                <p class="google-font mt-0 hidden-sm-and-down">Hier findes du all unsere Projekte. Du kannst Spiele spielen, Programme nutzen oder dich einfach nur inspirieren.</p>
                <p class="google-font mt-0 ">Für Fragen, Feedback oder Codeanfragen stehen wir gerne per Chat oder Mail zur Verfügung. E-Mail: <a style="color:#1565C0;text-decoration: none;" :href="`mailto:feedback@holy-code.de `">feedback@holy-code.de</a></p>
                
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name:'ProjektHeader'
}
</script>